import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import { localApi, credentials, localApib2b } from "utils/imgApi";
import { BiEdit } from "react-icons/bi";
import Compressor from "compressorjs";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import styleDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import styleBtn from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const style = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center",
  },
  cardCategory: {
    margin: "0",
    color: "#999999",
  },
};

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleDrop = makeStyles(styleDrop);
const useStyleSweet = makeStyles(styleSweet);
const useStyleBtn = makeStyles(styleBtn);

export default function ImagesAdd(props) {
  const [items, setItems] = React.useState([]);
  const [items1, setItems1] = React.useState([]);
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [simpleSelectErr, setSimpleSelectErr] = React.useState("");
  const [simpleSelect1, setSimpleSelect1] = React.useState("");
  const [simpleSelect1Err, setSimpleSelect1Err] = React.useState("");
  const [checkedFullSize, setCheckedFullSize] = React.useState(false);
  const [getId, setGetId] = React.useState("");
  const [getcatId, setGetcatId] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");

  const [newImage, setNewImage] = React.useState(false);
  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const classDrop = useStyleDrop();
  const history = useHistory();
  const classSweet = useStyleSweet();
  const classBtn = useStyleBtn();

  const { search } = useLocation();
  const a = new URLSearchParams(search).get("a");

  const [file, setFile] = React.useState(null);
  const [fileErr, setFileErr] = React.useState(null);
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    props.avatar ? "" : ""
  );
  let fileInput = React.createRef();

  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      setFile(file);
      setImagePreviewUrl(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    setFileErr("");
  };

  const handleClick = () => {
    fileInput.current.click();
  };
  const handleRemove = () => {
    setFile(null);
    setImagePreviewUrl(props.avatar ? "" : "");
    fileInput.current.value = null;
  };
  let { avatar, addButtonProps, changeButtonProps, removeButtonProps } = props;

  async function getCat() {
    const api = localApib2b + `/category/list/byAdminId/${a ? a : "2"}`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    setItems(getResult);
  }

  useEffect(() => {
    getCat();
    // catApi().then((res) => setItems(res));
  }, []);

  const handleSimple = async (event) => {
    // setSimpleSelect(event.target.value);
    const { value } = event.target;
    const item = items.find((item) => item.id === value);
    setSimpleSelect(value);
    setGetId(item.id);
    const response = await axios.get(
      localApib2b + `/parent/list/byCategoryId/${item.id}`,
      {
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      }
    );
    setItems1(response.data);
    setSimpleSelectErr("");
  };

  const handleSimple1 = (event) => {
    // setSimpleSelect(event.target.value);
    const { value } = event.target;
    const itemm = items1.find((itemm) => itemm.id === value);
    setSimpleSelect1(value);
    setGetcatId(itemm.id);
    // console.log(imgApi + "" + itemm.image);
    setSimpleSelect1Err("");
  };

  const SubmitAddImage = (e) => {
    setNewImage(true);
    let errorCount = 0;
    if (simpleSelect === "" || !simpleSelect) {
      errorCount++;
      setSimpleSelectErr("Select Category");
    }
    if (simpleSelect1 === "" || !simpleSelect1) {
      errorCount++;
      setSimpleSelect1Err("Select Product Size");
    }
    if (file === "" || !file) {
      errorCount++;
      setFileErr("of fix size (atleast width-280, height-336 pixel)");
    }
    if (errorCount === 0) {
      new Compressor(file, {
        quality: 0.8, // 0.6 can also be used, but its not recommended to go below.
        success: (compressedResult) => {
          const compressFile = new File([compressedResult], `${file?.name}`, {
            type: compressedResult.type,
          });
          // console.log(compressFile);
          setBtn(true);

          let fData = new FormData();
          fData.append("cropImage", compressFile);
          fData.append(
            "data",
            new Blob(
              [
                JSON.stringify({
                  adminId: a ? a : "1",
                  categoryId: getId,
                  parentId: getcatId,
                }),
              ],
              {
                type: "application/json",
              }
            )
          );

          axios
            .post(localApib2b + "/image/addImage", fData, {
              headers: {
                Authorization: `Basic ${credentials}`,
              },
            })
            .then((response) => {
              // console.log(response.data);
              if (response.data.message === "Image Inserted Successfully") {
                alertTypeOps("success");
                alertMsgOps("Succesfully !!!");
                setSubmitted(true);
              }
            });
        },
      });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    // history.push("admin-management://Image Option");
    window.location.reload(false);
  };

  useEffect(() => {
    // console.log("Value Changed")
    setSimpleSelect1("");
    setGetcatId("");
  }, [simpleSelect]);

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <form>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <BiEdit />
                </CardIcon>
                <h3 className={classes.cardIconTitle}>
                  <small>Add Fix Image</small>
                  {newImage === true ? (
                    <small
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginLeft: "10px",
                      }}
                    >
                      {simpleSelectErr || simpleSelect1Err || fileErr}
                    </small>
                  ) : (
                    <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                      of fix size (atleast width-280, height-336 pixel)
                    </small>
                  )}
                </h3>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  {submitted ? (
                    <SweetAlert
                      type={alertType}
                      style={{ display: "block", marginTop: "-100px" }}
                      title={alertMsg}
                      onConfirm={() => hideAlert()}
                      confirmBtnCssClass={
                        classSweet.button + " " + classSweet.success
                      }
                    >
                      Added Fix Image
                    </SweetAlert>
                  ) : null}{" "}
                  <GridItem xs={12} sm={6} md={6}>
                    <FormControl
                      fullWidth
                      className={classDrop.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classDrop.selectLabel}
                      >
                        Select Category Title...
                      </InputLabel>

                      <Select
                        MenuProps={{
                          className: classDrop.selectMenu,
                        }}
                        classes={{
                          select: classDrop.select,
                        }}
                        value={simpleSelect}
                        onChange={handleSimple}
                        inputProps={{
                          name: "simpleSelect",
                          id: "simple-select",
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classDrop.selectMenuItem,
                          }}
                        >
                          Select Category title...
                        </MenuItem>
                        {items &&
                          items.map((item) => (
                            <MenuItem
                              key={item.id}
                              value={item.id}
                              classes={{
                                root: classDrop.selectMenuItem,
                                selected: classDrop.selectMenuItemSelected,
                              }}
                            >
                              {item.title}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>{" "}
                  <GridItem xs={12} sm={6} md={6}>
                    <FormControl
                      fullWidth
                      className={classDrop.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classDrop.selectLabel}
                      >
                        Select Bangles Size-MM...
                      </InputLabel>

                      <Select
                        MenuProps={{
                          className: classDrop.selectMenu,
                        }}
                        classes={{
                          select: classDrop.select,
                        }}
                        value={simpleSelect1}
                        onChange={handleSimple1}
                        inputProps={{
                          name: "simpleSelect",
                          id: "simple-select",
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classDrop.selectMenuItem,
                          }}
                        >
                          Select Bangles Size-MM...
                        </MenuItem>
                        {items1 &&
                          items1.map((item1) => (
                            <MenuItem
                              key={item1.id}
                              value={item1.id}
                              classes={{
                                root: classDrop.selectMenuItem,
                                selected: classDrop.selectMenuItemSelected,
                              }}
                            >
                              {item1.title}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>{" "}
                  <GridItem xs={12} sm={12} md={12}>
                    <div className="fileinput text-center">
                      <input
                        type="file"
                        onChange={handleImageChange}
                        ref={fileInput}
                      />

                      <div
                        className={"thumbnail" + (avatar ? " img-circle" : "")}
                      >
                        {imagePreviewUrl && (
                          <img src={imagePreviewUrl} alt="..." />
                        )}
                      </div>
                      <GridContainer>
                        {file === null ? (
                          <Button
                            color="rose"
                            round
                            {...addButtonProps}
                            onClick={() => handleClick()}
                          >
                            {avatar ? "Add Photo" : "Add Image"}
                          </Button>
                        ) : (
                          <span>
                            <Button
                              color="rose"
                              round
                              {...changeButtonProps}
                              onClick={() => handleClick()}
                            >
                              Change
                            </Button>
                            {avatar ? <br /> : null}
                            <Button
                              color="rose"
                              round
                              {...removeButtonProps}
                              onClick={() => handleRemove()}
                            >
                              <i className="fas fa-times" /> Remove
                            </Button>
                          </span>
                        )}
                      </GridContainer>
                    </div>
                  </GridItem>{" "}
                </GridContainer>
                {btn === true ? (
                  <Button className={classBtn.updateProfileButton}>Add</Button>
                ) : (
                  <Button
                    color="rose"
                    onClick={SubmitAddImage}
                    className={classBtn.updateProfileButton}
                  >
                    Add
                  </Button>
                )}
              </CardBody>
            </Card>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}

ImagesAdd.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
